export default __webpack_public_path__ + "static/media/extra_off.d2398199.svg";